import { render } from "./AssignmentStatus.vue?vue&type=template&id=3e2cd82e&scoped=true"
import script from "./AssignmentStatus.vue?vue&type=script&lang=js"
export * from "./AssignmentStatus.vue?vue&type=script&lang=js"

import "./AssignmentStatus.vue?vue&type=style&index=0&id=3e2cd82e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2cd82e"]])

export default __exports__